/*
 *  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 */
import React, { useState } from 'react';
import { Icon } from 'semantic-ui-react';

import FilterForm from './FilterForm';
import FilterList from './FilterList';

const iconStyle = { lineHeight: 1, height: '1em', margin: 0 };

// expected props
// - mode, as string of either 'or' or 'and'
// - filters, as array of { key, value:[], match, icon }
// - fields, as array of { key, icon, label, options }
// - onFilter({ filters, mode })
export default function FilterBox({ mode = 'or', filters = [], fields, onFilter }) {
  const [expanded, setExpanded] = useState(true);

  return (
    <div className="workspace-card" style={{ marginBottom: '16px', marginTop: '16px', overflow: 'visible' }}>
      <button
        onClick={() => setExpanded(!expanded)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          width: '100%',
          padding: '14px 20px',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          fontFamily: 'inherit',
          fontSize: '0.9em',
          fontWeight: 600,
          color: 'var(--rmit-blue)',
          textAlign: 'left',
        }}
      >
        <Icon name="filter" style={iconStyle} />
        <span>Filters</span>
        {!expanded && filters.length > 0 && (
          <span style={{ marginLeft: '4px', fontSize: '0.85em', fontWeight: 500, color: '#6b7280' }}>
            ({filters.length} active)
          </span>
        )}
        <Icon name={expanded ? 'chevron up' : 'chevron down'} style={{ ...iconStyle, marginLeft: 'auto', fontSize: '0.8em', color: '#9ca3af' }} />
      </button>
      {!expanded && filters.length > 0 && (
        <div style={{ padding: '0 20px 12px', borderTop: '1px solid #f3f4f6' }}>
          <FilterList mode={mode} filters={filters} />
        </div>
      )}
      {expanded && (
        <div style={{ padding: '0 20px 16px', borderTop: '1px solid #e5e7eb' }}>
          <div style={{ paddingTop: '14px' }}>
            <FilterForm mode={mode} filters={filters} fields={fields} onFilter={onFilter} />
          </div>
        </div>
      )}
    </div>
  );
}
